// extracted by mini-css-extract-plugin
export default {"img":"Image_img__0WMus","wrapper":"Image_wrapper__NjpMr","imgFull":"Image_imgFull__ZhZMO","dialog":"Image_dialog__OhfX3"};